import React from 'react';
import { Form } from 'react-bootstrap';

export default function ContractFormFields({ form, onChange, showProgress = false }) {
  const update = (field, value) => onChange(field, value);

  return (
    <div className="row g-3">
      <div className="col-12">
        <Form.Label>Номер договора</Form.Label>
        <Form.Control
          value={form.number}
          onChange={(e) => update('number', e.target.value)}
          required
          placeholder="ДГ-2026/001"
        />
      </div>
      <div className="col-sm-4">
        <Form.Label>Количество, шт.</Form.Label>
        <Form.Control
          type="number"
          min="1"
          value={form.quantity}
          onChange={(e) => update('quantity', e.target.value)}
          required
        />
      </div>
      <div className="col-sm-4">
        <Form.Label>Цена за ед., ₽</Form.Label>
        <Form.Control
          type="number"
          min="0"
          step="0.01"
          value={form.price_per_unit}
          onChange={(e) => update('price_per_unit', e.target.value)}
          required
        />
      </div>
      <div className="col-sm-4">
        <Form.Label>Сумма, ₽</Form.Label>
        <Form.Control
          type="number"
          min="0"
          step="0.01"
          value={form.amount}
          onChange={(e) => update('amount', e.target.value)}
          required
        />
      </div>
      <div className="col-sm-6">
        <Form.Label>Дата начала</Form.Label>
        <Form.Control
          type="date"
          value={form.start_date}
          onChange={(e) => update('start_date', e.target.value)}
          required
        />
      </div>
      <div className="col-sm-6">
        <Form.Label>Дата завершения</Form.Label>
        <Form.Control
          type="date"
          value={form.end_date}
          onChange={(e) => update('end_date', e.target.value)}
          required
        />
      </div>
      {showProgress && (
        <div className="col-sm-6">
          <Form.Label>Прогресс, %</Form.Label>
          <Form.Control
            type="number"
            min="0"
            max="100"
            value={form.progress}
            onChange={(e) => update('progress', e.target.value)}
            placeholder="0–100"
          />
          <Form.Text className="app-text-muted">
            Обычно считается автоматически по стадиям. Можно задать вручную.
          </Form.Text>
        </div>
      )}
    </div>
  );
}
